import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const analyticsLayoutDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type AnalyticsLayoutUniDriver = ReturnType<
  typeof analyticsLayoutDriverFactory
>;
